
import ApplicationFormSection from '../components/VisaComp/ApplicationFormSection'
import ApplicationSteps from '../components/VisaComp/ApplicationSteps'
import Badge from '../components/VisaComp/Badge'
import HeroSection from '../components/VisaComp/HeroSection'
import SupportCTA from '../components/VisaComp/SupportCTA'
import VisaTypes from '../components/VisaComp/VisaTypes'



function VisaServicePage() {
  return (
    <div>
      <HeroSection />
      <Badge />
      <VisaTypes />
      <ApplicationSteps />
      <ApplicationFormSection />
      <SupportCTA />

    </div>
  )
}

export default VisaServicePage
